/**
 * Camera / mic toggle controls with clear on/off affordance.
 */
export function MediaToggles({
  cameraOn,
  micOn,
  canMedia,
  onToggleCamera,
  onToggleMic,
  buttonStyle = {},
}) {
  return (
    <>
      <button
        type="button"
        aria-pressed={cameraOn}
        aria-label={cameraOn ? "Camera on, click to turn off" : "Camera off, click to turn on"}
        title={cameraOn ? "Camera is on — click to turn off" : "Camera is off — click to turn on"}
        onClick={onToggleCamera}
        disabled={!canMedia}
        style={{
          ...styles.toggle,
          ...buttonStyle,
          ...(cameraOn ? styles.on : styles.off),
        }}
      >
        <span style={styles.kind}>Camera</span>
        <span style={styles.state}>{cameraOn ? "On" : "Off"}</span>
      </button>
      <button
        type="button"
        aria-pressed={micOn}
        aria-label={micOn ? "Microphone on, click to mute" : "Microphone off, click to unmute"}
        title={micOn ? "Mic is on — click to mute" : "Mic is off — click to unmute"}
        onClick={onToggleMic}
        disabled={!canMedia}
        style={{
          ...styles.toggle,
          ...buttonStyle,
          ...(micOn ? styles.on : styles.micOff),
        }}
      >
        <span style={styles.kind}>Mic</span>
        <span style={styles.state}>{micOn ? "On" : "Off"}</span>
      </button>
    </>
  );
}

const styles = {
  toggle: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "8px 12px",
    borderRadius: 8,
    border: "2px solid",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
    minWidth: 148,
  },
  kind: {
    fontWeight: 700,
  },
  state: {
    fontVariantNumeric: "tabular-nums",
    padding: "2px 8px",
    borderRadius: 999,
    background: "rgba(255,255,255,0.55)",
    fontSize: 13,
  },
  on: {
    background: "#d1fae5",
    borderColor: "#059669",
    color: "#065f46",
  },
  off: {
    background: "#f3f4f6",
    borderColor: "#9ca3af",
    color: "#374151",
  },
  micOff: {
    background: "#fee2e2",
    borderColor: "#dc2626",
    color: "#991b1b",
  },
};
